/**
 * Email validation regex pattern (RFC 5322 compliant subset).
 */
export const EMAIL_PATTERN = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

/**
 * Validates an email address using the EMAIL_PATTERN regex.
 * @param email - The email address to validate.
 * @returns True if valid, false otherwise.
 */
export const validEmail = function (email: string): boolean {
    return EMAIL_PATTERN.test(email);
};

